module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (59).192387df.jpg";